import { initVisualFilters, initTabbableVisualFilters } from '../modules/VisualFilters';
import { generateMediaElement } from '../services/media-content.service';
import { capitalizeFirstLetter } from '../helpers/transformations';
import { getElementOrParentByClassName, waitForElements } from '../helpers/utils';
import '../../styles/templates/_collection-v2.scss';
import LazyImages from '../modules/LazyImages';
import { boostQueryParamNumber } from '../helpers/boost-query-params.helper';
import { scrollTo } from '../helpers/scrollPage';
const typeToFunction = {
    "editorial-card": generateMediaElement
};
window.addEventListener("filter.afterInit", () => {
    if (window.UTK_content?.tabbableVisualFilters) {
        initTabbableVisualFilters();
    }
    else if (window.UTK_content?.visualFilters) {
        initVisualFilters();
    }
    if (window.UNTUCKitConfig?.thirdPartyToggles?.boostAutoSelectLoadPrevious) {
        const loadPrevBtn = document.querySelector(".js-boost-pfs-filter-btn-load-previous-page");
        if (loadPrevBtn && boostQueryParamNumber(window.Globals?.queryParams?.page) > 1) {
            setTimeout(() => {
                const observer = new IntersectionObserver((entries, observer) => {
                    const entry = entries[0];
                    if (entry.isIntersecting) {
                        entry.target.click();
                        observer.disconnect();
                    }
                }, {
                    threshold: [0.5]
                });
                observer.observe(loadPrevBtn);
            }, 1000); // TODO: better way to provide some time for boost to scroll down the page?
        }
    }
    // attempt at "anchoring" to a specific editorial card
    const editorial = new URLSearchParams(location.search).get('editorial');
    if (editorial) {
        waitForElements(`#${editorial}`).then((els) => {
            scrollTo(els[0]);
        });
    }
});
window.addEventListener("filter.afterRender", async () => {
    // accessibility fix for boost checkboxes
    document.querySelectorAll('.boost-pfs-check-box[aria-labelledby]').forEach(el => {
        el.setAttribute('aria-label', el.getAttribute('aria-labelledby'));
        el.removeAttribute('aria-labelledby');
    });
    if (document.querySelector('color-swatch-list[data-populated="false"]')) {
        fetch(`/collections/${window.collectionHandle}/?view=color-swatches`).then((res) => {
            if (res.ok) {
                return res.json();
            }
        }).then((colorSwatchConfig) => {
            if (colorSwatchConfig) {
                Object.entries(colorSwatchConfig).filter((e) => e[1].length).forEach((e) => {
                    const handle = e[0];
                    const swatchHtml = e[1];
                    const el = document.querySelector(`color-swatch-list[data-populated="false"][data-product-handle="${handle}"]`);
                    if (el) {
                        el.innerHTML = swatchHtml;
                        el.setAttribute('data-populated', 'true');
                    }
                });
            }
        }).catch((e) => {
            console.error(e);
        });
    }
});
window.addEventListener("filter.addEditorialContent", async () => {
    await addEditorialContent(window.UTK_content);
    repositionEditorialElements();
});
let currentDeviceType = getDeviceType();
window.addEventListener("resize", function () {
    const newDeviceType = getDeviceType();
    if (currentDeviceType !== newDeviceType) {
        currentDeviceType = newDeviceType;
        repositionEditorialElements();
    }
});
window.addEventListener("click", handleHideFilter);
async function addEditorialContent(config) {
    console.log("addEditorialContent");
    const gridContainer = getGridContainer();
    const hasExistingContent = gridContainer.querySelectorAll(".editorial-content").length > 0;
    if (config && !hasExistingContent) {
        console.log("no existing editorial content; adding");
        if (config.defaultEditorialContentSetup && config.defaultEditorialContentSetup.slots) {
            config.defaultEditorialContentSetup.slots.forEach(function (s) {
                const card = s.defaultCard;
                if (card) {
                    if (skipEditorialCard(card, s.hideWhenFilterApplied)) {
                        console.log("skipping editorial card", card);
                        return;
                    }
                    let cardEl;
                    const cardElFunc = typeToFunction[card._type];
                    if (cardElFunc) {
                        const overrides = {
                            imageSrcset: [375, 390, 414, 428, 768, 800, 1024, 1280, 1440],
                            sizes: "33vw, 50vw, (max-width: 1440px) 100vw, 1440px"
                        };
                        cardEl = cardElFunc(card, overrides);
                    }
                    else {
                        throw new Error("card el generator not defined for type");
                    }
                    cardEl.classList.add("card-" + card.size, "editorial-content", "boost-pfs-filter-product-item", "boost-pfs-filter-product-item-grid", "hidden");
                    cardEl.dataset.size = card.size;
                    ["mobile", "tablet", "desktop"].forEach((device) => {
                        if (s[`display${capitalizeFirstLetter(device)}`]) {
                            cardEl.dataset[`${device}Location`] = s[`${device}Location`];
                            cardEl.dataset[`${device}Row`] = s[`${device}Row`];
                            cardEl.dataset[`${device}Column`] = s[`${device}Column`];
                        }
                    });
                    gridContainer.append(cardEl);
                }
                else {
                    // note: cards may be intentionally left out (e.g. hiding specific cards for certain segments)
                    console.warn("no card defined for slot", s);
                }
            });
        }
    }
}
function getGridContainer() {
    return document.querySelector(".boost-pfs-filter-products");
}
/**
 * determines if a card should be skipped.
 * (e.g. a card that applies a filter shouldn't show if that filter is already applied, etc)
 */
function skipEditorialCard(card, hideWhenFilterApplied) {
    let skipCard = false;
    const cardUrl = card.url;
    const isFilteredPage = location.href.includes("pf_");
    if (isFilteredPage && hideWhenFilterApplied) {
        skipCard = true;
    }
    else if (cardUrl) {
        const isProductCard = cardUrl.includes("/products/");
        const isSamePage = cardUrl.includes(location.pathname);
        if (isProductCard && isFilteredPage) {
            skipCard = true;
        }
        else if (isSamePage) {
            const cardQueryParams = new URLSearchParams(cardUrl.substring(cardUrl.indexOf("?")));
            const pageQueryParams = new URLSearchParams(location.search);
            const allCardQueryParamsApplied = !Array.from(cardQueryParams.entries()).find(([key, val]) => {
                return pageQueryParams.get(key) !== val;
            });
            if (allCardQueryParamsApplied) {
                skipCard = true;
            }
        }
    }
    return skipCard;
}
/**
 * repositons editorial content within the product list
 * so that they sit in the correct locations (for keyboard users)
 */
function repositionEditorialElements() {
    const queryParams = window.Globals?.queryParams;
    if (!queryParams) {
        return;
    }
    const page = boostQueryParamNumber(queryParams.page, 1);
    const limit = boostQueryParamNumber(queryParams.limit);
    let previousPageSlots = (page - 1) * limit;
    console.log("repositionEditorialElements");
    const content = Array.from(document.querySelectorAll(".editorial-content"));
    if (content) {
        const gridContainer = getGridContainer();
        const device = getDeviceType();
        let overallDummySlots = 0;
        const numCols = isMobileTablet() ? 2 : 3;
        content
            .sort((a, b) => editorialSort(a, b, device))
            .forEach((c) => {
            const location = c.dataset[device + "Location"];
            if (!location) {
                c.classList.add("hidden");
            }
            else {
                let added = false;
                if (location === "first" && isFirstPage()) {
                    gridContainer.prepend(c);
                    added = true;
                }
                else if (location === "last" && isLastPage()) {
                    gridContainer.append(c);
                    added = true;
                }
                else {
                    const previousPageFullRows = Math.floor(previousPageSlots / numCols);
                    const row = +(c.dataset[device + "Row"] || 0) - previousPageFullRows;
                    const col = +(c.dataset[device + "Column"] || 0);
                    const position = (row - 1) * numCols + col - overallDummySlots;
                    // position might be negative if user is on page > 1
                    if (position > 0) {
                        const referenceNode = gridContainer.children[position - 1];
                        if (referenceNode) {
                            gridContainer.insertBefore(c, referenceNode);
                            added = true;
                        }
                        else {
                            const payload = { text: c.textContent, row: row, col: col };
                            console.warn("Unable to set card; not enough products in grid.", payload);
                        }
                    }
                    else {
                        previousPageSlots += getNumCardSlots(c);
                    }
                }
                if (added) {
                    c.classList.remove("hidden");
                    const dummySlots = getNumCardSlots(c) - 1;
                    overallDummySlots += dummySlots;
                }
            }
        });
    }
    LazyImages.update();
}
function getNumCardSlots(cardEl) {
    const size = cardEl.dataset.size; // e.g. 2x1
    let cols = +size[0];
    if (isMobileTablet() && cols === 3) {
        cols = 2;
    }
    const rows = +size[2];
    return cols * rows;
}
function editorialSort(a, b, device) {
    const aLocation = a.dataset[device + "Location"];
    const aRow = +a.dataset[device + "Row"];
    const aColumn = +a.dataset[device + "Column"];
    const bLocation = b.dataset[device + "Location"];
    const bRow = +b.dataset[device + "Row"];
    const bColumn = +b.dataset[device + "Column"];
    // location will be NaN if not intended to be displayed on device
    if (!aLocation && !bLocation) {
        return 0;
    }
    else if (!aLocation) {
        return 1;
    }
    else if (!bLocation) {
        return -1;
    }
    else if (aLocation === "first" || bLocation === "last") {
        return -1;
    }
    else if (bLocation === "first" || aLocation === "last") {
        return 1;
    }
    else {
        if (aRow < bRow) {
            return -1;
        }
        else if (bRow < aRow) {
            return 1;
        }
        else {
            return aColumn < bColumn ? -1 : bColumn < aColumn ? 1 : 0;
        }
    }
}
/**
 * gets device type by window width
 * mimics getDeviceType from constants/devices.js
 */
function getDeviceType() {
    return window.innerWidth < 768 ? "mobile" : window.innerWidth < 1024 ? "tablet" : "desktop";
}
/**
 * mobile and tablet are intended to be treated the same in most instances
 * mimics isBelowDesktop from constants/devices.js
 */
function isMobileTablet() {
    return ["mobile", "tablet"].includes(getDeviceType());
}
function isFirstPage() {
    return boostQueryParamNumber(window.Globals?.queryParams?.page, 1) === 1;
}
function isLastPage() {
    const queryParams = window.Globals?.queryParams;
    if (!queryParams) {
        return false;
    }
    const collectionCount = window.Globals?.collectionCount;
    if (collectionCount == null) {
        return false;
    }
    const limit = boostQueryParamNumber(queryParams.limit);
    if (!limit) {
        return false;
    }
    const page = boostQueryParamNumber(queryParams.page, 1);
    return Math.ceil(collectionCount / limit) === page;
}
function handleHideFilter(e) {
    const target = e.target;
    const filterToggle = getElementOrParentByClassName(target, "js-hide-filter");
    if (filterToggle) {
        const text = filterToggle.querySelector(".hide-filter__text");
        text.textContent = text.textContent.includes("Hide") ? "Show Filter" : "Hide Filter";
        filterToggle.querySelector('.hide-filter__icon').classList.toggle("reverse");
        document.querySelector(".boost-pfs-filter-left-col").classList.toggle("hidden");
        const resultsEl = document.querySelector(".boost-pfs-filter-right-col");
        resultsEl.classList.toggle("full-width");
        const editorialCards = document.querySelectorAll('.editorial-content');
        editorialCards.forEach((e) => e.classList.toggle('editorial-content--large'));
    }
}
